import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { ElMessage } from 'element-plus'
import { apiDirectGift } from '@/api/gameApi'
import { apiAddCartGoods, apiAddCartGoodsV2, apiGoodsCheckCpSkus, apiGoodsListAll } from '@/api/goodsApi'
import { useLanguageStore } from '@/store/modules/language'
import { useGameStore } from '@/store/modules/game'
import { UseReportData } from '@/hooks/useReportData'
import { useAuthStore } from '@/store/modules/auth'
import { useGoodsStore } from '@/store/modules/goodsStore'
import { useCommonStatus } from '@/store/modules/commonStaus'
// import eventBus, { COMMON_EVENT_NAME } from '@/utils/eventBus'
import { useDevice } from '@/hooks/useDevice'
import { NOT_ALLOWED_BUY_PC } from '@/hooks/useGameConfig'
import { dayjsFormat } from '@/utils/dayjs'
import i18n from '@/i18n'
import { GoodsItemType, IPayMethod, ISkuList } from '@/@types/types'
import { debounce } from '@/utils/utils'
import { useVoucherStore } from '@/store/modules/voucher'
import { usePayHooks } from '@/views/mall/payGoods/payModal/usePayHooks'
import { CommonConstants } from '@/common/constants'

let goodsListRequest:
  | {
      key: string
      promise: Promise<void>
    }
  | null = null

export const UseMallHooks = () => {
  const { updatePayList } = usePayHooks()
  const currentTab = ref(-1)
  const isShowMoreGiveaway = ref(false)
  const goodsListLoading = ref(false)
  const route = useRoute()
  const { setAuthVisible } = useAuthStore()
  const { verifyRole, currentPayType } = storeToRefs(useAuthStore())
  const { homeReqLoading, cartIconRef, cartIconRefMobile } = storeToRefs(useCommonStatus())
  const { currentCountry } = storeToRefs(useLanguageStore())
  const { preCheck, currentGameId, currentGameConfig } = storeToRefs(useGameStore())
  const { setPreCheckList } = useGameStore()
  const { setSingleGoods, setPayVisible, setPayMethod, setCartGoodsList, setDiscountGoodsList } =
    useGoodsStore()
  const {
    singleGoods,
    singlePriceData,
    allGoodsList,
    allDiscountList,
    cartGoodsList,
    cartPriceData,
    payMethod,
    cartCount
  } = storeToRefs(useGoodsStore())
  const { $customEvent } = UseReportData()
  const { isMobileReal } = useDevice()
  // const buyOpenBtnLoading = ref(false)
  const { setUseVoucherList, setCurrentNid, setCurrentVoucher } = useVoucherStore()
  const { currentNid } = storeToRefs(useVoucherStore())
  const { setFreeGiftSuccessVisible } = useCommonStatus()

  //  1 代币，2 礼包，3 订阅，4 免费
  const getGoodsList = async (isUpdateVoucher?: boolean | undefined) => {
    console.log('isUpdateVoucher', isUpdateVoucher)
    const params = {
      mall_game_id: currentGameConfig.value.id,
      sku_status: 1,
      payRegion: currentCountry.value.key,
      cpUid: verifyRole.value.cpUid
    }
    const requestKey = JSON.stringify(params)
    if (goodsListRequest?.key === requestKey) {
      return goodsListRequest.promise
    }

    homeReqLoading.value = true
    const requestPromise = (async () => {
      const res = await apiGoodsListAll(params)
      if (res.code !== 0) {
        return
      }
      allGoodsList.value = res.data?.dataList || []
      allDiscountList.value = res.data?.recommendList || []
      // 删除默认选中第一个游戏
      // if (allGoodsList.value.length > 0 && !currentGoods.value) {
      //   setCurrentGoods(res.data[0].skuList[0])
      // }
      isShowMoreGiveaway.value = false
      if(allGoodsList.value.length) {
        for (let i = 0; i < allGoodsList.value.length; i++) {
          allGoodsList.value[i].skuList.forEach(item => {
            if(item.award) {
              isShowMoreGiveaway.value = true
            }
          })
        }
      }

      if (verifyRole.value.cpUid && preCheck.value) {
        await getPreCheckSku()
      }
      // if (cartGoodsList.value.length > 0) {
      //   handleCartGoodsOp()
      // }
      changeVoucherOrPayToCheckCart()
      // 删除更新商品数据
      // updateGoodsData()

      // 删除更新优惠券
      // if (verifyRole.value.cpUid && isUpdateVoucher) {
      //   getUseVoucherList(
      //     currentCountry.value.key,
      //     currentGameConfig.value.id,
      //     verifyRole.value.role_id,
      //     verifyRole.value.server_id,
      //     discountPrice.value,
      //     false
      //   )
      // }
    })()

    goodsListRequest = {
      key: requestKey,
      promise: requestPromise
    }
    return requestPromise.finally(() => {
      if (goodsListRequest?.key === requestKey) {
        goodsListRequest = null
        homeReqLoading.value = false
      }
    })
  }

  const getPreCheckSku = async () => {
    const params = {
      skus: [] as string[],
      role_id: verifyRole.value.role_id,
      mall_game_id: currentGameConfig.value.id,
      server_id: verifyRole.value.server_id
    }

    allGoodsList.value.forEach(item => {
      params.skus.push(...item.skuList.map(o => o.sku))
    })

    const res = await apiGoodsCheckCpSkus(params)
    if (res.code !== 0) return
    setPreCheckList(res.data)
  }

  const getSingleGoodsData = (goods: GoodsItemType) => {
    if (!cartGoodsList.value.length) {
      setSingleGoods(goods)
      return
    }
    const index = cartGoodsList.value.findIndex(item => item.sku === goods.sku)
    if (index !== -1) {
      setSingleGoods(cartGoodsList.value[index])
    } else {
      setSingleGoods(goods)
    }
  }

  // 拉起购买弹窗
  const handleBuyOpenModal = async (goods?: GoodsItemType) => {
    if (NOT_ALLOWED_BUY_PC.includes(route.path) && !isMobileReal.value) {
      ElMessage.warning('暂不支持PC端购买，请使用手机打开商城下单购买')
      return
    }
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)
      return
    }
    $customEvent('wm_pay', {})
    if (goods?.sku_type === 4) {
      await handleGetFreeGift(goods)
      return
    }
    setPayVisible(true)
  }

  // 领取免费礼包
  const handleGetFreeGift = async (goods: GoodsItemType) => {
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)
      return
    }
    const res: any = await apiDirectGift({
      sku: goods?.sku,
      mall_game_id: currentGameId.value,
      cpUid: verifyRole.value.role_id,
      server_id: verifyRole.value.server_id
    })

    if (res.code === 0) {
      setFreeGiftSuccessVisible(true)
    } else if (res.code === -2) {
      ElMessage.warning(res.msg)
    } else {
      if (!res.data) {
        ElMessage.warning(res.msg)
        return
      }

      ElMessage.warning(`${i18n.global.t('i18n-next-pick-up-time')}${dayjsFormat(res.data)}`)

      const data = localStorage.getItem('nextPickUpTime')
      if (data) {
        const nextPickUpTime = JSON.parse(data)
        nextPickUpTime[goods!.sku] = res.data
        localStorage.setItem('nextPickUpTime', JSON.stringify(nextPickUpTime))
      } else {
        const nextPickUpTime = {
          [goods!.sku]: res.data
        }
        localStorage.setItem('nextPickUpTime', JSON.stringify(nextPickUpTime))
      }
    }
  }

  // 添加商品数量，区分是购物车添加还是单个商品的数量添加
  const handleAddGoodsNum = (goods: GoodsItemType, type: 'add' | 'sub', payMethod: IPayMethod) => {
    if (payMethod === 'cart') {
      handleAddCartGoodsNum(goods, type)
    } else {
      handleAddSingleGoodsNum(goods, type)
    }
  }

  // 确认订单页面的添加单个商品数量
  const handleAddSingleGoodsNum = (goods: GoodsItemType, type: 'add' | 'sub') => {
    switch (type) {
      case 'add':
        goods.num++
        break
      case 'sub':
        if (goods.num === 1) {
          break
        }
        goods.num--
        break
      default:
        break
    }

    decounceAddSingleGoods()
  }

  const handleAddNumCart = (goods: GoodsItemType, type: 'add' | 'sub') => {
    // if (
    //   CommonConstants.IS_NOT_USE_CART_PAY.includes(currentPayTypeId.value) &&
    //   cartGoodsList.value.length
    // ) {
    //   ElMessage.warning('当前支付方式不支持同时购买多个')
    //   return false
    // }
    switch (type) {
      case 'add':
        goods.num++
        break
      case 'sub':
        if (goods.num === 1) {
          // 移除购物车的这个数据
          cartGoodsList.value = cartGoodsList.value.filter(item => item.sku !== goods.sku)
          break
        }
        goods.num--
        break
      default:
        break
    }
    return true
  }

  // 确认订单页面的添加商品数量
  const handleAddCartGoodsNum = (goods: GoodsItemType, type: 'add' | 'sub') => {
    if (!handleAddNumCart(goods, type)) {
      return
    }

    if (cartGoodsList.value.length === 0) {
      cartPriceData.value = null
      setPayVisible(false)
    }
    syncCartDataToGoodsList()
    debounceCartGoodsOp()
  }

  // 商品列表的添加数量
  const handleGoodsNum = (goods: GoodsItemType, type: 'add' | 'sub') => {
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)
    }

    if (!handleAddNumCart(goods, type)) {
      return
    }
    setCurrentNid(-1)
    if (cartGoodsList.value.length === 0) {
      cartPriceData.value = null
    }
    syncGoodsListToCartData()
    debounceCartGoodsOp()
  }

  // 添加商品预检方法（sdk的预检）
  const sdkPreCheckGoods = async (
    skuList: ISkuList[],
    type: 'cart' | 'single',
    isOpenModal: boolean = false
  ) => {
    if (!skuList.length) {
      return
    }

    console.log(9999, currentNid.value)

    homeReqLoading.value = true
    let result: any
    if (CommonConstants.IS_CN) {
      result = await apiAddCartGoods({
        payId: currentPayType.value,
        payRegion: currentCountry.value.key,
        skuList,
        nid: currentNid.value ?? -1
      }).finally(() => {
        homeReqLoading.value = false
      })
    } else {
      result = await apiAddCartGoodsV2({
        payRegion: currentCountry.value.key,
        skuList,
        nid: currentNid.value ?? -1
      }).finally(() => {
        homeReqLoading.value = false
      })
    }

    if (result?.code === 0 || result?.code === -111) {
      if (result?.code === -111) {
        ElMessage.info(result.msg)
      }

      setUseVoucherList(result.data.benefitList)
      setDiscountGoodsList(result.data.orderInfoList || [])
      if (result.data?.nid) {
        setCurrentNid(result.data.nid)
        const index = result.data.benefitList?.findIndex(item => item.id === result.data.nid)
        if (index !== -1) {
          setCurrentVoucher(result.data.benefitList[index])
        } else {
          setCurrentVoucher(null)
        }
      } else {
        setCurrentNid(-1)
        setCurrentVoucher(null)
      }
      if (result.data?.displayList) {
        updatePayList(result.data.displayList, result.data.hiddenList, result.data?.payId)
      }
      if (type === 'single') {
        singleGoods.value = result.data.dataList || []
        singlePriceData.value = {
          currentAmount: result.data.currentAmount || 0,
          currentCurrency: result.data.currentCurrency || '',
          maxNum: result.data.maxNum || 10,
          originAmount: result.data.originAmount || 0,
          currentNum: result.data.currentNum || 0
        }
        if (result.data.dataList.length) {
          // 拉起支付弹窗
          setPayMethod('single')
          handleBuyOpenModal()
        }
      } else {
        cartGoodsList.value = result.data.dataList || []
        cartPriceData.value = {
          currentAmount: result.data.currentAmount || 0,
          currentCurrency: result.data.currentCurrency || '',
          maxNum: result.data.maxNum || 10,
          originAmount: result.data.originAmount || 0,
          currentNum: result.data.currentNum || 0
        }
        cartCount.value = result.data.currentNum || 0
        // 同步数据
        syncCartDataToGoodsList()
        if (isOpenModal) {
          handleBuyOpenModal()
        }
      }
      return
    }
    if (result.code === -1000) {
      return
    }
    ElMessage.warning(result.msg)
  }

  // 确认订单页面调用添加购物车商品
  const handleCartGoodsOp = async (isOpenModal: boolean = false) => {
    const skuList = cartGoodsList.value.map(item => {
      return {
        num: item.num,
        sku: item.sku
      }
    })
    console.log('isOpenModal', isOpenModal)
    sdkPreCheckGoods(skuList, 'cart', isOpenModal)
  }

  const debounceCartGoodsOp = debounce((isOpenModal: boolean = false) => {
    handleCartGoodsOp(isOpenModal)
  }, 200)

  const handleAddSingleGoods = async (isOpenModal: boolean = true) => {
    const skuList = singleGoods.value.map(item => {
      return {
        num: item.num,
        sku: item.sku
      }
    })

    sdkPreCheckGoods(skuList, 'single', isOpenModal)
  }

  const decounceAddSingleGoods = debounce((isOpenModal: boolean) => {
    handleAddSingleGoods(isOpenModal)
  }, 200)

  const changeVoucherOrPayToCheckCart = () => {
    if (payMethod.value === 'single') {
      decounceAddSingleGoods()
    } else {
      debounceCartGoodsOp()
    }
  }

  const clearCartGoods = () => {
    setPayVisible(false)
    setCartGoodsList([])
    cartPriceData.value = null
    syncCartDataToGoodsList()
    // if (!verifyRole.value.cpUid) {
    //   setAuthVisible(true)
    // }
  }

  // 同步商品列表数据到购物车数据
  const syncGoodsListToCartData = () => {
    cartGoodsList.value.forEach(item => {
      allGoodsList.value.forEach(p => {
        p.skuList.forEach(t => {
          if (t.sku === item.sku) {
            item.num = t.num
          }
        })
      })
    })
    cartGoodsList.value.forEach(item => {
      allDiscountList.value.forEach(t => {
        if (t.sku === item.sku) {
          item.num = t.num
        }
      })
    })
  }

  // 同步购物车数量到商品列表
  const syncCartDataToGoodsList = () => {
    allGoodsList.value.forEach(item => {
      item.skuList.forEach(p => {
        const cartGoods = cartGoodsList.value.find(o => o.sku === p.sku)
        if (cartGoods) {
          p.num = cartGoods.num
        } else {
          p.num = 1
        }
      })
    })

    allDiscountList.value.forEach(item => {
      const cartGoods = cartGoodsList.value.find(o => o.sku === item.sku)
      if (cartGoods) {
        item.num = cartGoods.num
      } else {
        item.num = 1
      }
    })
  }

  // 加入购物车（初始按钮）
  const handleAddCart = (goods: GoodsItemType) => {
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)
      return
    }
    setCurrentNid(-1)
    cartGoodsList.value.push(goods)
    handleCartGoodsOp()
  }

  // 购物车拉起支付弹窗
  const handleBuyCartGoods = () => {
    setCurrentNid(-1)
    $customEvent('wm_click_cart_icon_open', {})
    setPayMethod('cart')
    debounceCartGoodsOp(true)
  }

  const handleBuySingleGoods = async (goods: GoodsItemType) => {
    if (!verifyRole.value.cpUid) {
      setAuthVisible(true)
      return
    }
    if (goods.sku_type === 4) {
      handleGetFreeGift(goods)
      return
    }
    setCurrentNid(-1)
    getSingleGoodsData(goods)
    handleAddSingleGoods()
  }

  const handleAddToCart = (startPos:any) => {
    let endRect;
    let endPos;
    if(isMobileReal.value) {
      endRect = cartIconRefMobile.value?.getBoundingClientRect();
      if (!endRect) {
        console.error('购物车图标未找到');
        return;
      }
       endPos = {
          x: (endRect.left + 18) + endRect.width / 2,
          y: (endRect.top - 12) + endRect.height / 2
        };
    } else {
      const endRect = cartIconRef.value?.getBoundingClientRect();
      if (!endRect) {
        console.error('购物车图标未找到');
        return;
      }
      endPos = {
        x: (endRect.left + 30) + endRect.width / 2,
        y: (endRect.top - 10) + endRect.height / 2
      };
    }

    console.log('endPos', endPos)
    createFlyingBall(startPos, endPos, () => {
      cartCount.value += 1;
    });
  }

  function createFlyingBall(startPos: { x: number; y: number }, endPos: { x: number; y: number },   onComplete: () => void) {
    // 创建小球
    const ball = document.createElement('div');
    const R = 6; // 小球半径
    ball.style.cssText = `
    position: fixed;
    width: ${R * 2}px;
    height: ${R * 2}px;
    border-radius: 50%;
    background: red;
    left: ${startPos.x - R}px;
    top: ${startPos.y - R}px;
    pointer-events: none;
    z-index: 9999;
  `;
    document.body.appendChild(ball);

    const duration = isMobileReal.value ? 500 : 700;       // 动画时长 ms
    const arcHeight = 150;      // 抛物线顶点相对直线的最大高度（可调）
    const startTime = performance.now();

    function animate(now: number) {
      const t = Math.min((now - startTime) / duration, 1);
      // ease-out 插值（可选）
      const easeT = 1 - (1 - t)**3;

      // X 线性插值
      const x = startPos.x + (endPos.x - startPos.x) * easeT;
      // Y = 线性 + “抛物线高度” * 4t(1−t)，保证 t=0/1 时附加项为 0
      const yLinear = startPos.y + (endPos.y - startPos.y) * easeT;
      const yParabola = arcHeight * 4 * easeT * (1 - easeT);
      const y = yLinear - yParabola;

      ball.style.left = `${x - R}px`;
      ball.style.top = `${y - R}px`;

      if (t < 1) {
        requestAnimationFrame(animate);
      } else {
        // 动画结束，移除小球
        document.body.removeChild(ball);
        onComplete();
      }
    }

    requestAnimationFrame(animate);
  }


  return {
    currentTab,
    goodsListLoading,
    allGoodsList,
    allDiscountList,
    currentGameConfig,
    isShowMoreGiveaway,
    getGoodsList,
    handleBuyOpenModal,
    handleGoodsNum,
    handleAddGoodsNum,
    handleAddCart,
    handleCartGoodsOp,
    handleAddCartGoodsNum,
    clearCartGoods,
    handleBuySingleGoods,
    handleBuyCartGoods,
    debounceCartGoodsOp,
    changeVoucherOrPayToCheckCart,
    handleAddToCart
  }
}
